// extracted by mini-css-extract-plugin
export default {"zoomControls":"t--z","zoomControlButton":"u--z","zoomBanner":"v--z","bannerButton":"w--z","imageButton":"x--z","zoom":"y--z","zoomContent":"z--z"};